/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface RevokeRoles$Params {
  userId: string;
      body: Array<'PRODUCT_ADMIN' | 'PRICING_ADMIN' | 'MERCHANT_ADMIN' | 'COMMERCIAL_ADMIN' | 'EXCISE_MANAGER' | 'SUBSCRIPTION_ADMIN' | 'SETTINGS_ADMIN' | 'USER_ADMIN' | 'SUPPLY_MANAGER' | 'EASYLOT_ADMIN' | 'TELESALES' | 'TECHNICAL_USER' | 'IMPERSONATION' | 'PRICE_SYNC_ADMIN' | 'PRICE_SYNC' | 'PRODUCT_SYNC' | 'STOCK_SYNC' | 'PRODUCT_MAPPING_REQUEST_ADMIN'>
}

export function revokeRoles(http: HttpClient, rootUrl: string, params: RevokeRoles$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, revokeRoles.PATH, 'delete');
  if (params) {
    rb.path('userId', params.userId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

revokeRoles.PATH = '/users/{userId}/roles';
